<app-zoomer> 
  <div class="map-svg-container" #mapSvgContainerRef ></div> 
</app-zoomer>